import React from "react";

const MensajeError = (props) => {   
    let componente = null;

    if (props.huboError) {
       componente = <div className="row bottom-separator-xs alert-danger nivelar-alert-danger">
            <div className="col-xs-12">
                <label className="error">Hay datos que requieren ser completados para crear un registro de parámetro</label>
            </div>
        </div>
    }
    
    return componente;

}

export default MensajeError